/**
 * Le parole di «Modifica sul sito» (editing in place sul dominio pubblicato,
 * D-19). Separate da dict.ts solo per tenerlo leggibile; entrano negli stessi
 * due alberi, quindi `dict.test.ts` li controlla come gli altri.
 */
import type { DictNode } from './dict.js'

export const inPlaceIt: DictNode = {
  inplace: {
    editOnSite: 'Modifica sul sito',
    explain: {
      title: 'Modifica sul sito',
      off: 'Questo sito non ha acceso la modifica in pagina. Accendila nelle impostazioni del sito, poi pubblica di nuovo il sito: le pagine online avranno il piccolo collegamento che apre l’editor, solo per chi ha una sessione.',
      notOnline: 'La pagina non è ancora online, quindi non c’è un indirizzo pubblico da aprire. Pubblicala, poi torna qui: finché non è online la modifichi dal CMS.',
      noAddress: 'Non riesco a ricavare l’indirizzo pubblico di questo elemento da qui. Aprilo dal sito, poi aggiungi #cms-edit in fondo all’indirizzo.',
      openSettings: 'Apri le impostazioni',
    },
    list: {
      off: 'Non attiva per questo sito',
      notOnline: 'Non è ancora online',
      noAddress: 'Indirizzo non calcolabile da qui',
    },
    card: {
      title: 'Modifica in pagina sul sito',
      intro: 'Chi ha una sessione del CMS può modificare testi e immagini direttamente sulla pagina pubblicata. Chi legge il sito non riceve nulla in più.',
      toggle: 'Consenti la modifica sul sito pubblicato',
      toggleHelp: 'Spenta di default. Salvare una modifica non pubblica niente: la pubblicazione resta un gesto a parte.',
      hosts: 'Domini dove può partire l’editor',
      hostsHelp: 'Solo i domini registrati per il sito. Se li lasci tutti selezionati valgono tutti, anche quelli aggiunti dopo.',
      noHost: 'Scegli almeno un dominio, oppure spegni l’opzione.',
      publishAgain: 'Dopo il salvataggio pubblica di nuovo il sito: le pagine già online non hanno ancora il collegamento.',
      shortcut: 'Per entrare in modifica da qualsiasi pagina del sito aggiungi ?cms-edit all’indirizzo (per esempio /contatti?cms-edit). Dopo la prima volta, in questo browser resta un piccolo tasto «Modifica» in basso a destra: lo vedi solo tu, i lettori no.',
    },
    reason: {
      on: 'Accendo la modifica in pagina sul sito pubblicato',
      off: 'Spengo la modifica in pagina sul sito pubblicato',
    },
  },
}

export const inPlaceEn: DictNode = {
  inplace: {
    editOnSite: 'Edit on the site',
    explain: {
      title: 'Edit on the site',
      off: 'This site has not turned editing in place on. Turn it on in the site settings, then publish the site again: the live pages will carry the small link that opens the editor, only for people with a session.',
      notOnline: 'The page is not online yet, so there is no public address to open. Publish it, then come back; until then you edit it from the CMS.',
      noAddress: 'I cannot work out the public address of this item from here. Open it on the site, then add #cms-edit at the end of the address.',
      openSettings: 'Open the settings',
    },
    list: {
      off: 'Not turned on for this site',
      notOnline: 'Not online yet',
      noAddress: 'Address cannot be worked out from here',
    },
    card: {
      title: 'Editing in place on the published site',
      intro: 'People with a CMS session can edit texts and images right on the published page. Readers of the site receive nothing more.',
      toggle: 'Allow editing on the published site',
      toggleHelp: 'Off by default. Saving a change publishes nothing: publishing stays a separate action.',
      hosts: 'Domains where the editor may start',
      hostsHelp: 'Only domains registered for the site. Leave them all selected and every one counts, including ones added later.',
      noHost: 'Pick at least one domain, or turn the option off.',
      publishAgain: 'After saving, publish the site again: the pages already online do not have the link yet.',
      shortcut: 'To start editing from any page of the site, add ?cms-edit to the address (for example /contact?cms-edit). After the first time, a small «Edit» button stays at the bottom right of this browser: only you see it, readers do not.',
    },
    reason: {
      on: 'Turn on editing in place on the published site',
      off: 'Turn off editing in place on the published site',
    },
  },
}
